export const LoanDocumentPaneTestIds = {
  CLOSE_BUTTON: 'loan-document-pane.close-button',
};
